@use '@fukuri-admins/ui/layout' as *;

.shell {
  display: flex;
  align-items: center;
  gap: spacing('8');
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 spacing('12');
  background-color: background('Primary');
  border: 1px solid border('Quaternary');
  border-radius: borderRadius('lg');

  &:focus-within {
    outline: none;
    // border-color は Quaternary のまま変更しない
    box-shadow: 0 0 0 3px border('Focus');
  }

  &.error {
    border-color: border('Red_Darken');

    &:focus-within {
      // border-color は Red_Darken のまま維持し、box-shadow リングは Focus（青）に統一
      box-shadow: 0 0 0 3px border('Focus');
    }
  }

  &.disabled {
    cursor: not-allowed;
  }
}

.startIcon {
  display: inline-flex;
  align-items: center;
  color: text('Placeholder');
  flex-shrink: 0;

  .shell:focus-within & {
    color: text('High');
  }

  .shell.disabled & {
    color: text('Disabled');
  }
}

.input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: 0;
  padding: 0;
  background: transparent;
  font-family: inherit;
  @include typography('Jp/14_W3');
  color: text('High');

  &::placeholder {
    color: text('Placeholder');
  }

  &:disabled {
    color: text('Disabled');
    cursor: not-allowed;
  }
}
